export const QuestionSelectionError = "Invalid Selection";